export default __webpack_public_path__ + "../staticImages/bg-brown.webp";